<template>
    <div>
        <v-card-text>
            <customer-table
                :search="search"
                :items="customers"
                :options="pagination"
                @viewDetails="viewCustomerDetails"/>
        </v-card-text>

        <right-panel
            ref="customerDetailsPanel"
            :title="$t('customerList.customerDetails.header')">
            <template v-slot:content="{ context }" >
                <customer-details-view
                    :customer="context"/>
            </template>

            <template v-slot:bottom="{ context }">
                <button-status-field
                    v-if="context"
                    :status="$constant.ACTIVE_STATUS"
                    :status_color="context.status"
                    @click="onClickPanelActive(context)"/>
                <button-status-field
                    v-if="context"
                    class="ml-0"
                    :status="$constant.INACTIVE_STATUS"
                    :status_color="context.status"
                    @click="onClickPanelInActive(context)"/>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="updateCustomer(context)">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </div>
</template>

<script>
import RightPanel from '@/components/panels/RightPanel'
import CustomerTable from '@/components/tables/CustomerTable'
import CustomerDetailsView from '@/views/CustomerDetailsView'
import ButtonStatusField from '@/components/fields/ButtonStatusField'

import { mapGetters } from 'vuex'

export default {
    name: 'CustomerListView',

    components: {
        CustomerTable,
        CustomerDetailsView,
        ButtonStatusField,
        RightPanel
    },

    props: {
        customers: {
            type: Array,
            default: () => []
        },

        search: {
            type: String,
            default: ''
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            filter: {
                nationality: this.$t('customerList.allNationality'),
                status: this.$constant.ACTIVE_STATUS
            },

            statusList: [
                this.$constant.ACTIVE_STATUS,
                this.$constant.INACTIVE_STATUS,
                this.$constant.ALL_STATUS
            ],

            nationalityList: [
                this.$t('customerList.allNationality')
            ]
        }
    },

    computed: {
        ...mapGetters({
            getCustomerById: 'customer/getCustomerById'
        })
    },

    methods: {
        async updateCustomer (customer) {
            const { CustomerID, ...updateCustomer } = customer
            await this.$store.dispatch('customer/updateCustomer', updateCustomer)
            this.$refs.customerDetailsPanel.close()
            this.$emit('fetch')
        },

        async viewCustomerDetails (customerItem) {
            const customer = await this.getCustomerById(customerItem.id)
            this.$refs.customerDetailsPanel.open(customer)
        },

        onClickPanelActive (customer) {
            this.$set(customer, 'status', this.$constant.ACTIVE_STATUS)
        },

        onClickPanelInActive (customer) {
            this.$set(customer, 'status', this.$constant.INACTIVE_STATUS)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-select {
    .v-select__selection {
        text-transform: capitalize;
    }
}
</style>
